<template>
  <div
    :id="id"
    class="group cursor-pointer flex items-center select-none hover:bg-background rounded-md p-2 transition-colors"
    :class="nested ? 'text-sm' : 'text-base'"
  >
    <slot name="icon">
      <!-- Default icon slot -->
    </slot>
    <span class="truncate grow" :class="{ 'font-medium': !nested }">
      <slot />
    </span>
    <SvgIcon
      icon="ArrowRight"
      class="text-secondary shrink-0 ml-2 opacity-0 group-hover:opacity-100 transition-opacity"
    />
  </div>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/misc/SvgIcon'

defineProps<{
  id?: string
  nested?: boolean
}>()
</script>
